import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row, Button, Form, Dropdown } from 'react-bootstrap';
import { FaShareAlt, FaInstagram, FaFacebook, FaWhatsapp, FaLinkedin } from 'react-icons/fa';
import Header from '../components/Header';
import ShopContext from '../context/shop/shopContext';
import Loading from '../components/Loading';
import xLogo from '../assets/x.png';  

const Blog = () => {
  const { getPosts, posts, orderLoading } = useContext(ShopContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(2);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResult, setSearchResult] = useState([]);

  useEffect(() => {
    getPosts();
  }, []);

  const calculateTimeDifference = (dateString) => {
    const parseDate = (dateString) => {
      const [day, month, year] = dateString.split('/');
      return new Date(`${month}/${day}/${year}`);
    };
  
    const date = parseDate(dateString);
    const now = new Date();
    const diffInMs = now - date;
  
    const seconds = Math.floor(diffInMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30.44); // Approximate month length
    const years = Math.floor(days / 365);
  
    if (years > 0) return `${years} year${years > 1 ? 's' : ''} ago`;
    if (months > 0) return `${months} month${months > 1 ? 's' : ''} ago`;
    if (weeks > 0) return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
    if (days > 0) return `${days} day${days > 1 ? 's' : ''} ago`;
  
    if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    if (minutes > 0) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    return `${seconds} second${seconds > 1 ? 's' : ''} ago`;
  };
  
  

  const formatViews = (views) => {
    if (views >= 1_000_000_000) {
      return `${(views / 1_000_000_000).toFixed(1)}B`;
    } else if (views >= 1_000_000) {
      return `${(views / 1_000_000).toFixed(1)}M`;
    } else if (views >= 1_000) {
      return `${(views / 1_000).toFixed(1)}k`;
    }
    return views.toString();
  };

  const [showExact, setShowExact] = useState(false);
const [views, setViews] = useState(0); 
    const handleClick = () => {
      setShowExact(!showExact);
    };

  useEffect(() => {
    if (posts) {
      // Sorting posts by date after they are fetched
      const sortedPosts = [...posts].sort((a, b) => {
        const parseDate = (dateString) => {
          const [day, month, year] = dateString.split('/');
          return new Date(`${month}/${day}/${year}`); // Construct Date object from dd/mm/yyyy
        };
  
        return parseDate(b.date) - parseDate(a.date); // Sort from latest to oldest
      });
  
      setSearchResult(sortedPosts);
    }
  }, [posts]);
  

  const handleSearchInputChange = (event) => setSearchQuery(event.target.value);

  const handleSearchClick = () => {
    if (searchQuery.trim() === '') {
      setSearchResult([]);
    } else {
      const result = posts.filter((post) =>
        post.title.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setSearchResult(result);
    }
  };

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = searchResult.length > 0 ? searchResult.slice(indexOfFirstPost, indexOfLastPost) : (posts || []).slice(indexOfFirstPost, indexOfLastPost);

  const handlePreviousClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextClick = () => {
    const maxPage = Math.ceil((searchResult.length > 0 ? searchResult.length : (posts || []).length) / postsPerPage);
    if (currentPage < maxPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const sharePost = (post, platform) => {
    const shareUrl = `${window.location.origin}/post/${post.id}`;
    const text = `Check out this post: ${post.title}`;

    let url = '';
    if (platform === 'facebook') {
      url = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
    } else if (platform === 'x') { // Fix for Twitter/X sharing URL
      url = `https://twitter.com/intent/tweet?url=${shareUrl}&text=${text}`;
    } else if (platform === 'whatsapp') {
      url = `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}%20${encodeURIComponent(shareUrl)}`;
    } else if (platform === 'linkedin') {
      url = `https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`;
    }
      else if (platform === 'instagram') {
    // Instagram does not allow direct sharing via URL. Instead, we'll use an Instagram deep link.
    // Instagram deep links only work with media URLs e.g., images/videos.
    // Instagram requires the app to be installed for sharing images, so we use a generic Instagram URL.
    url = `https://www.instagram.com/create/style/`;
  }
    window.open(url, '_blank');
  };

  if (posts === null) {
    return (
      <div style={{ minHeight: '75vh' }}>
        <Header
          image='https://images.unsplash.com/photo-1497008386681-a7941f08011e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1480&q=80'
          title='Our Blog'
          subTitle='KEEPING YOU WELL INFORMED'
        />
        <Container>
          <div
            className='d-flex align-items-center justify-content-center'
            style={{ height: 200 }}
          >
            <Loading />
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '75vh' }}>
      <Header
        image='https://images.unsplash.com/photo-1497008386681-a7941f08011e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1480&q=80'
        title='Our Blog'
        subTitle='KEEPING YOU WELL INFORMED'
      />

      <Container>
        <Form>
          <Form.Group controlId='search'>
            <Form.Control
              type='text'
              placeholder='Search blog posts...'
              onChange={handleSearchInputChange}
              value={searchQuery}
              style={{ maxWidth: '300px', marginTop: '20px' }}
            />
            <Button
              onClick={handleSearchClick}
              style={{ marginLeft: '8px', marginTop: '5px', color: 'white', backgroundColor: 'green' }}
            >
              Search
            </Button>
          </Form.Group>
        </Form>

        {orderLoading ? (
          <div
            className='d-flex align-items-center justify-content-center'
            style={{ height: 200 }}
          >
            <Loading />
          </div>
        ) : (
          <>
            {currentPosts.length === 0 ? (
              <div>No matching blog posts found.</div>
            ) : (
              currentPosts.map((post) => (
                <div key={post.id}>
                  <Row className='align-items-center'>
                    <Col md={4}>
                      <div
                        className='d-flex justify-content-center'
                        style={{ marginTop: 60 }}
                      >
                      <Link to={`/post/${post.id}`} style={{ width: '100%' }}>
                        <div
                          style={{
                            backgroundImage: `url(${post.image})`,
                            width: '100%',
                            height: 350,
                            backgroundPosition: 'center',
                            backgroundSize: 'cover',
                            borderRadius: 5,
                          }}
                        ></div>
                        </Link>
                      </div>
                    </Col>
                    <Col md={8}>
                      <div>
                        <p>
                        <Link to={`/post/${post.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                        {calculateTimeDifference(post.date)} | {post.category} 
                        </Link>
                        </p>
                        <h1>
                        <Link to={`/post/${post.id}`} style={{ textDecoration: 'none', color: 'inherit', fontSize:'30px' }}>
                        {post.title}
                        </Link>
                        </h1>
                        <p>
                        <Link to={`/post/${post.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                          {`${post.description.slice(0, 150)}...`}
                        </Link>
                          </p>

                        <p>
                     <span
                      style={{ cursor: 'pointer', textDecoration: 'none' }}
                       onClick={handleClick}
                          title={showExact ? 'Click to show formatted view' : 'Click to show exact number'}
                         >
                         {showExact ? post.views.toLocaleString() : formatViews(post.views)}
                           </span>
                         <strong> Views</strong>
                         </p>
                        <Link to={`/post/${post.id}`}>
                          <Button variant='link' style={{ color: 'green', padding: 0 }}>
                            Continue reading
                          </Button>
                        </Link>
                        <Dropdown style={{ display: 'inline-block', marginLeft: '10px' }}>
                          <Dropdown.Toggle variant="light" id="share-dropdown" style={{ borderRadius: '50%', backgroundColor:'#40FF40' }}>
                            <FaShareAlt /> Share
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                          <Dropdown.Item onClick={() => sharePost(post, 'instagram')}>
                          <FaInstagram style={{ color: '#E4405F', marginBottom: '3px' }} /> Share on Instagram
                           </Dropdown.Item>
                            <Dropdown.Item onClick={() => sharePost(post, 'facebook')}>
                              <FaFacebook style={{ color: '#3b5998', marginBottom: '3px' }} /> Share on Facebook
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => sharePost(post, 'x')}>
                              <img 
                                src={xLogo} 
                                alt="X Logo" 
                                style={{ width: '15px', height: '15px', marginBottom: '2px', borderRadius: '100px', marginRight:'7px' }} 
                              />
                              Share on X
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => sharePost(post, 'whatsapp')}>
                              <FaWhatsapp style={{ color: '#25D366', marginBottom: '3px' }} /> Share on WhatsApp
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => sharePost(post, 'linkedin')}>
                              <FaLinkedin style={{ color: '#0077b5', marginBottom: '3px' }} /> Share on LinkedIn
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </Col>
                  </Row>
                </div>
              ))
            )}

            <div className='d-flex justify-content-center mt-4'>
              <Button
                onClick={handlePreviousClick}
                disabled={currentPage === 1}
                className='mr-2'
                style={{ backgroundColor: 'green' }}
              >
                Previous
              </Button>
              <Button
                onClick={handleNextClick}
                disabled={(searchResult.length > 0 ? currentPosts.length : posts.length) < postsPerPage}
                style={{ backgroundColor: 'green', marginLeft: '10px' }}
              >
                Next
              </Button>
            </div>
          </>
        )}
      </Container>
    </div>
  );
};

export default Blog;
